import axios from "axios";
import { endpoint } from "../utils/endpoints";

export const handleApiCall = async (method = "", url = "", data = {}, isPublic = false) => {

  // const apiUrl = isPublic ? `${process.env.REACT_APP_PUBLIC_API}${url}` : `${process.env.REACT_APP_API}${url}`;
  const apiUrl = `${process.env.REACT_APP_API}${url}`;
  console.log(apiUrl , "apiUrl");
  const isFormData = data && typeof FormData !== "undefined" && data instanceof FormData;
  let axiosConfig = {
    method,
    url: apiUrl,
    headers: {
      Authorization: `Bearer ${localStorage?.getItem("sessionToken")}`,
      ...(method !== "get" && !isFormData && { "Content-Type": "application/json" }),
    },
  };
  if (method === "get" && data?.params && typeof data.params === "object") {
    axiosConfig.params = data.params;
  } else if (method !== "get") {
    axiosConfig["data"] = data;
  }
  try {
    let response = await axios(axiosConfig);

    return response;
  } catch (error) {
    return error;
  }
};

/**
 * Sample price API: POST /v1/admin/sample-price
 * @param {Object} payload - { price_first_time, price_second_time, type, status }
 * @param {number} payload.price_first_time
 * @param {number} payload.price_second_time
 * @param {string} payload.type - "package_menu_items" | "custom_menu_items"
 * @param {number} payload.status - 1 (active) | 0 (inactive)
 */
export const saveSamplePrice = async (payload) => {
  return handleApiCall("post", endpoint.samplePrice, payload);
};
